// @flow

import {PrefixTypes} from '../constants';

import type {PrefixType} from '../constants';

type GetCurrPrefix = {
    prefix: string,
    id: string,
    index: number,
    prefixType: PrefixType,
};

export const getCurrPrefix = ({prefix, id, index, prefixType}: GetCurrPrefix): string => {
    switch (prefixType) {
        case PrefixTypes.NUMERATION:
            return `${prefix}${++index}.`;
        case PrefixTypes.ID:
            return `${id}.`;
        default:
            return '';
    }
};
